export function alertStatus(state, action) {
    switch (action.type) {
        case 'ALERT_SCOET_INFO_STATUS':
            return action.data
        default:
            return {...state};
    }
}